import React, { FC, useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import useLocalStorage from 'react-use-localstorage';
import Auth from '@aws-amplify/auth';
import { useIntl } from 'react-intl';

import { makeStyles, Button, Typography } from '@material-ui/core';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import LockOpenIcon from '@material-ui/icons/LockOpen';

import messages from './messages';
import { fetchAppConfigByProfileName } from '../Appconfig/fetchAppConfigByProfile';

const REPORT_PATH = '/report';
const REPORT_ONLY_USERS: string[] = [];

const useStyles = makeStyles((theme) => ({
	loginButton: {
		justifyContent: 'left',
		padding: theme.spacing(2),
		textTransform: 'capitalize'
	},
	linkText: { marginLeft: theme.spacing(0.5) }
}));

export const RequireAuth: FC = (props) => {
	const { push } = useHistory();
	const { pathname } = useLocation();
	const intl = useIntl();
	const [session, setSession] = useState<boolean>(false);
	const [, setItem] = useLocalStorage('loginpath', '');
	const { children } = props;

	fetchAppConfigByProfileName('mgmt_ui_appconfig_configs_profile').then(
		(config) => config && REPORT_ONLY_USERS.push(...(JSON.parse(config).reportOnlyUsers || []))
	);

	useEffect(() => {
		Auth.currentSession()
			.then(() => {
				setSession(true);
				window.setTimeout(() => setItem(''), 5000);
			})
			.catch(() => {
				setItem(window.location.pathname);
				setSession(false);
				Auth.federatedSignIn();
			});
	}, [setItem]);

	// If the user is report-only, redirect them to the report path if not there already
	if (session && pathname !== REPORT_PATH) {
		Auth.currentAuthenticatedUser()
			.then(({ attributes: { email } }) => {
				if (REPORT_ONLY_USERS.includes(email.toLowerCase())) {
					push(REPORT_PATH);
				}
			})
			.catch(() => {
				// If we can't get the user, just continue
			});
	}

	return session ? <>{children}</> : <Typography>{intl.formatMessage({ ...messages.noAccessNotice })}</Typography>;
};

export const AuthLink: FC = () => {
	const classes = useStyles();
	const intl = useIntl();
	const [username, setUsername] = useState<string>('');

	useEffect(() => {
		Auth.currentAuthenticatedUser()
			.then((user) => setUsername(user.username))
			.catch(() => setUsername(''));
	}, []);
	return username.length ? (
		<Button className={classes.loginButton} onClick={(): Promise<unknown> => Auth.signOut()}>
			<ExitToAppIcon style={{ marginRight: '0.5rem' }} />
			<Typography className={classes.linkText}>{intl.formatMessage({ ...messages.logout })}</Typography>
		</Button>
	) : (
		<Button className={classes.loginButton} onClick={(): Promise<unknown> => Auth.federatedSignIn()}>
			<LockOpenIcon style={{ marginRight: '0.5rem' }} />
			<Typography className={classes.linkText}>{intl.formatMessage({ ...messages.login })}</Typography>
		</Button>
	);
};
